<div>
  <button
    *showAuthed="true"
    (click)="DelCommunityAuthModal.show()"
    type="button"
    class="btn m-b-10 btn-md btn-block btn-danger"
  >
    <i class="icofont icofont-trash"></i>
    <span>Delete this uMuzi?</span>
    <!-- Content marker -->
    <ng-content></ng-content>
  </button>

  <del-community-auth-modal
    #DelCommunityAuthModal
    [community]="community"
    [hideFooter]="true"
  >
  </del-community-auth-modal>
</div>
